import { paymentRescheduleService } from '@afterpaytouch/portal-api/consumer/paymentReschedule'

export const {
  useGetPaymentRescheduleQuery,
  useLazyGetPaymentRescheduleQuery,
  useSetPaymentRescheduleMutation,
  endpoints: { getPaymentReschedule, setPaymentReschedule },
} = paymentRescheduleService
